import { Skeleton } from '@xefi/x-react/skeleton';

export const SurveyTakingSkeleton = () => {
   return (
      <div className='bg-content1-100 flex h-dvh justify-center px-10 py-4'>
         <div className='min-h-[calc(100dvh-5rem)] w-full max-w-5xl'>
            <div className='flex flex-col gap-6'>
               <div className='dark:bg-background flex h-[54px] items-center justify-between gap-4 rounded-lg bg-white px-4'>
                  <div className='flex items-center gap-3'>
                     <Skeleton className='size-6 rounded' />
                     <Skeleton className='h-4 w-32' />
                  </div>
                  <Skeleton className='h-4 w-48' />
               </div>
               <div className='dark:bg-background flex h-[calc(100dvh-7.875rem)] overflow-hidden rounded-lg bg-white'>
                  <div className='flex h-full w-full flex-col items-center gap-6 overflow-y-auto px-10 py-6'>
                     <Skeleton className='h-4 w-48 self-start' />
                     <div className='flex w-full flex-1 flex-col items-end justify-center gap-6'>
                        <Skeleton className='h-10 w-48 rounded-[6px]' />
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
};
